import * as React from 'react';
import { TDeliveryMethodSelector } from './DeliveryMethodSelector.types';
import './DeliveryMethodSelector.styled.scss';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import { Search } from '@mui/icons-material';

// Mock InPost paczkomaty data - replace with actual API integration
const mockInPostPoints = [
  { id: '1', name: 'Paczkomat 1', address: 'ul. Testowa 1, Warszawa' },
  { id: '2', name: 'Paczkomat 2', address: 'ul. Przykładowa 2, Kraków' },
  { id: '3', name: 'Paczkomat 3', address: 'ul. Demo 3, Gdańsk' },
];

export const DeliveryMethodSelector: TDeliveryMethodSelector = ({
  open,
  onClose,
  onSelect,
  deliveryMethod,
  postalCode,
}) => {
  const [searchTerm, setSearchTerm] = React.useState('');
  const [filteredPoints, setFilteredPoints] = React.useState(mockInPostPoints);

  React.useEffect(() => {
    if (searchTerm) {
      const filtered = mockInPostPoints.filter(
        (point) =>
          point.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          point.address.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredPoints(filtered);
    } else {
      setFilteredPoints(mockInPostPoints);
    }
  }, [searchTerm]);

  const handleSelect = (pointId: string, pointName: string) => {
    onSelect(pointId, pointName);
    onClose();
  };

  if (deliveryMethod !== 'inpost') {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select InPost Paczkomat</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Search paczkomat"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: <Search />,
          }}
          margin="normal"
        />
        <List>
          {filteredPoints.length === 0 ? (
            <Typography variant="body2" color="textSecondary" align="center">
              No paczkomaty found
            </Typography>
          ) : (
            filteredPoints.map((point) => (
              <ListItem key={point.id} disablePadding>
                <ListItemButton
                  onClick={() => handleSelect(point.id, point.name)}
                >
                  <ListItemText
                    primary={point.name}
                    secondary={point.address}
                  />
                </ListItemButton>
              </ListItem>
            ))
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
